import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as userActions from "../../../../actions/user.actions";

import CompanyPayment from "../components/CompanyPayment";

class CompanyPaymentContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.userActions.getUserData();
  }

  render() {
    return <CompanyPayment user={this.props.user} />;
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyPaymentContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/payment/containers/CompanyPaymentContainer.js